<div>
  <app-breadcrumb
    [breadcrumbItems]="{
      currentPageLink: '/contact-us',
      currentPage: 'Contact Us'
    }"
  />

  <div class="custom-container">
    <div class="contact-us-wrapper">
      <p class="section-title">Contact Us</p>
  
      <form class="contact-us-form">
        <div class="form-field">
          <label for="name">Name</label>
          <input type="text" id="name" />
        </div>
        <div class="form-field">
          <label for="email">Email Address</label>
          <input type="text" id="email" />
        </div>
        <div class="form-field">
          <label for="subject">Subject</label>
          <input type="text" id="subject" />
        </div>
        <div class="form-field">
          <label for="message">Message</label>
          <textarea id="message"></textarea>
        </div>
        <button class="form-btn">
          <img src="assets/icons/message.svg" alt="message" />
          <span>Send Message</span>
        </button>
      </form>
    </div>
  </div>
  
</div>